import type React from "react";
import { toResourceCards, types, type Topic } from "@module/resource";
import { sort, topic, type } from "@module/resource/store";
import { Select, SelectItem } from "@nextui-org/select";
import { useTranslatedRelative, translateGlossaries as ts } from "@i18next/client/utils";

interface Props {
  currentSite: Page.Site;
  exclude?: Array<string>;
  defaultType?: number;
  defaultTopic?: string;
  topics: Array<Topic>;
  glossaries?: Record<string, string>;
}

const Filter: React.FC<Props> = ({
  currentSite,
  defaultType = 0,
  defaultTopic = "",
  topics,
  glossaries: gs
}) => {
  const tr = useTranslatedRelative(currentSite.locale);
  type.set(defaultType);
  topic.set(defaultTopic);

  return (
    <div className="flex flex-wrap gap-4">
      {!defaultType && (
        <Select
          key={`filter-type`}
          variant="bordered"
          label={ts(gs, "Resource Type")}
          labelPlacement="outside"
          defaultSelectedKeys={[`${type.get()}`]}
          className="min-w-44 w-auto"
          onChange={e => {
            let _type = types[parseInt(e.target.value)];
            if(!_type.section) {
              globalThis.location.href=tr(_type.uri);
            } else {
              type.set(parseInt(e.target.value));
            }
          }}
        >
          {types.map((type, k) => (
            <SelectItem key={k} value={k}>{ts(gs, type.label)}</SelectItem>
          ))}
        </Select>
      )}
      <Select
        key={`filter-topic`}
        variant="bordered"
        label={ts(gs, "Topic")}
        labelPlacement="outside"
        defaultSelectedKeys={[topic.get() || ""]}
        onChange={e => {
          topic.set(e.target.value ?? undefined);
          toResourceCards();
        }}
        className="min-w-52 w-auto"
        classNames={{
          innerWrapper: "w-auto pr-unit-6",
          popoverContent: "w-auto",
          listboxWrapper: "w-auto"
        }}
      >
        {[
          <SelectItem key={""} value={""}>{ts(gs, "All Topics")}</SelectItem>,
          ...topics.map((t, i) => <SelectItem key={t.id} value={t.id}>{t.title}</SelectItem>)
        ]}
      </Select>
      <Select
        key={`filter-sort`}
        variant="bordered"
        label={ts(gs, "Sort")}
        labelPlacement="outside"
        defaultSelectedKeys={[sort.get()]}
        onChange={e => {
          sort.set(e.target.value);
          toResourceCards();
        }}
        className="min-w-24 w-auto"
      >
        <SelectItem key="latest" value="latest">{ts(gs, "Latest")}</SelectItem>
        <SelectItem key="oldest" value="oldest">{ts(gs, "Oldest")}</SelectItem>
      </Select>
    </div>
  );
}

export default Filter;